import { useCartData } from "@/zustand/cartStore";
import React, { useState } from "react";
import { useProductData } from "@/zustand/productStore";

const PurchaseTypeSelector = ({ onChange }) => {
  const [selected, setSelected] = useState(true);
  const { isSubscribe } = useCartData();
  const setIsSubscribe = useCartData((state) => state.setIsSubscribe);
  const setProductsBySubscription = useProductData((state) => state.setProductsBySubscription);
  const base = window.subscription_template;

  const handleSelect = (isSubscribe) => {
    setSelected(isSubscribe);
    setIsSubscribe(isSubscribe);
    setProductsBySubscription(isSubscribe);
    if (onChange) onChange(isSubscribe);
  };

  return (
    <div className="purchaseTypeSelector__wrapper">
      <div className="purchaseTypeSelector__container">
        <div
          className={`purchaseTypeSelector__option ${selected ? "purchaseTypeSelector__selected" : ""}`}
          onClick={() => handleSelect(true)}
          role="button"
          tabIndex={0}
          aria-pressed={selected}
        >
          {base?.tr_subscribe_and_save}
        </div>
        <div
          className={`purchaseTypeSelector__option ${!selected ? "purchaseTypeSelector__selected" : ""}`}
          onClick={() => handleSelect(false)}
          role="button"
          tabIndex={0}
          aria-pressed={!selected}
        >
          {base?.tr_one_time_purchase}
        </div>
      </div>
      <div className="purchaseTypeSelector__description">
        {isSubscribe ? base?.tr_subscription_description : base?.tr_onetime_description}
      </div>
    </div>
  );
};

export default PurchaseTypeSelector;
